import { ExternalModuleSource } from './mfe';
import { Region } from './regions';

export enum FedTier {
  IL4 = 'IL4',
  IL5 = 'IL5',
  IL6 = 'IL6',
  FEDRAMP = 'FEDRAMP',
}

export interface DevsiteEnvModel {
  /** When false, API Discovery Center is not available (set via `API_DISCOVERY_CENTER_ENABLED` in the env file). */
  API_DISCOVERY_CENTER_ENABLED: boolean;
  /** When false, MCP Explorer is not available (set via `MCP_EXPLORER_ENABLED` in the env file). */
  MCP_EXPLORER_ENABLED: boolean;
  ANALYTICS_DEBUG: boolean;
  ANALYTICS_URL: string;
  AOS_URL: string;
  API_DOMAIN: string;
  API_SUBDOMAIN: string;
  APPHUB_URL: string;
  /** When true, DevSite reverse-proxies APIs at `/api/*` and exchanges tokens via the DevSite BFF. Defaults from FED_MODE. */
  BFF_ENABLED: boolean;
  BUILD_WAIT_INTERNAL_MS: number;
  /** When true, login uses authorization-code + server secret instead of browser PKCE. Defaults from FED_MODE. */
  CODE_FLOW: boolean;
  GATEWAY_ROUTED_API_ENABLED: boolean;
  /** When false, the Discourse product-updates API is not available (set via `DISCOURSE_ENABLED` in the env file). */
  DISCOURSE_ENABLED: boolean;
  /** When true, show a confirmation before opening non-devsite HTTP(S) links (set via `EXTERNAL_LINK_BLOCKING_ENABLED` in the env file). */
  EXTERNAL_LINK_BLOCKING_ENABLED: boolean;
  DEVSITE_DOMAIN: string;
  DEVSITE_SESSION_TIMEOUT_ENABLED: boolean;
  DEVSITE_SESSION_TIMEOUT_IN_MINUTES: number;
  DEVSITE_URL: string;
  DEVTOOLS_SERVER_ENDPOINT: string;
  DIGITAL_DOMAIN: string;
  ENABLE_ANALYTICS: boolean;
  ENABLE_SUVS: boolean;
  ENV_LEVEL: string;
  EXPLORER_CLIENT_ID: string;
  /** Federal environment marker. When true, defaults BFF_ENABLED, CODE_FLOW, HTTP_ONLY_AUTH_ENABLED, and session timeout on. */
  FED_MODE: boolean;
  FED_TIER?: FedTier;
  FIPS_MODE: boolean;
  OMIT_REGION_ALIAS: boolean;
  FLOWBUILDER_ENDPOINT: string;
  FORUM_URL: string;
  GLOBAL_PRIMARY_REGION: Region;
  HAS_OPEN_DEVELOPER_ENVIRONMENT: boolean;
  HTTP_ONLY_AUTH_ENABLED: boolean;
  IS_INTERNAL_ENV: boolean;
  LOCAL_DEV_APP_PREVIEW_PROXY: boolean;
  LOCAL_DEV_FLOWBUILDER_PROXY: boolean;
  LOCAL_DEV_GATEWAY_PROXY: boolean;
  LOCAL_DEV_LOCAL_SESSION_APP_PREVIEW_PROXY: boolean;
  LOCAL_DEV_MALT_PROXY: boolean;
  LOCAL_DEV_STUDIOBUILDER_PROXY: boolean;
  LOCAL_SESSION_APP_PREVIEW_ENDPOINT: string;
  MALT_URL: string;
  MIXPANEL_TOKEN: string;
  OCTO_DEVSITE_ID: string;
  OCTO_OKTA_INTEGRATION: boolean;
  PIPEDREAM_API_ENABLED: boolean;
  OCTOPAAS_CLIENT: string;
  OCTOPAAS_CLIENT_OPEN_DEV?: string;
  OCTOPAAS_URL: string;
  OCTOPAAS_URL_OPEN_DEV?: string;
  PMD_APP_PREVIEW_BASE_ENDPOINT: string;
  PUBLIC_RESOURCES_ENABLED: boolean;
  ROBOT_URL: string;
  SCRIPT_PREVIEW_URL: string;
  SECURE_COOKIE: boolean;
  SENTRY: {
    CLIENT_FQDN?: string;
    DSN?: {
      [key in ExternalModuleSource]?: {
        CLIENT_KEY?: string;
        PROJECT_ID?: number;
      };
    };
    ENABLED?: boolean;
    REPLAY: {
      ERROR_SAMPLE_RATE?: number;
      SESSION_SAMPLE_RATE?: number;
    };
    TRACES?: {
      SAMPLE_RATE?: number;
      TARGETS?: string[];
    };
  };
  SOLUTIONS_MARKETPLACE: string;
  STUDIOBUILDER_ENDPOINT: string;
  SUBDOMAIN_API_BASE_URL: string;
  SUPPORT_ENDPOINT: string;
  TEZCA_STATE_URL: string;
  VERSION: string;
}
